






































































import Vue from 'vue';
import VuePortal from '@linusborg/vue-simple-portal';
import LazyLoadDirective from './LazyLoadDirective.ts';
import CoRoundButton from '../co-round-button/CoRoundButton.vue';

Vue.use(VuePortal);

export default {
    name: 'CoImage',
    components: {
        CoRoundButton,
    },
    directives: {
        lazyload: LazyLoadDirective,
    },
    props: {
        src: {
            type: String,
            default: '',
        },
        alt: {
            type: String,
            default: '',
        },
        placeholder: {
            type: String,
            default: null,
            validator: (value: string | null) => ['image', 'user', 'page', 'event', null].includes(value),
        },
        placeholderSize: {
            type: String,
            default: '',
        },
        placeholderFormat: {
            type: String,
            default: 'default',
            validator: (value: string) => ['default', 'portrait', 'landscape', 'square'].includes(value),
        },
        placeholderDisabled: {
            type: Boolean,
            default: false,
        },
        objectFit: {
            type: String,
            default: 'cover',
            validator: (value: string) => ['cover', 'contain'].includes(value),
        },
        imageWidthAuto: {
            type: Boolean,
            default: false,
            required: false,
        },
        lightbox: {
            type: Boolean,
            default: false,
        },
        rounded: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            lightboxShow: false,
            lightboxLoaded: false,
        };
    },
    watch: {
        src() {
            this.$nextTick(() => {
                if (this.$refs.imageWrapper && this.$refs.imageWrapper.reloadImage) {
                    this.$refs.imageWrapper.reloadImage();
                }
            });
        },
    },
    computed: {
        url() {
            if (!this.src) {
                return '';
            }

            //  if start https://cdnmedia.coapp.io/ or https://media.coapp.io/ return as is
            if (this.src.startsWith('https://cdnmedia.coapp.io/') || this.src.startsWith('https://media.coapp.io/')) {
                return this.src;
            }
            // if imageURL starts with https://collaborates.s3.eu-central-1.amazonaws.com/ remove from url
            let tmp = this.src;
            if (this.src && this.src.startsWith('https://collaborates.s3.eu-central-1.amazonaws.com/')) {
                tmp = tmp.replace('https://collaborates.s3.eu-central-1.amazonaws.com/', '');
            } else if (this.src && this.src.startsWith('https://projects-headers.s3.eu-central-1.amazonaws.com/')) {
                tmp = tmp.replace('https://projects-headers.s3.eu-central-1.amazonaws.com/', '');
            } else {
                return this.src;
            }

            // replace / with _ in the url
            tmp = tmp.replace(/\//g, '_');

            //  and new prefix https://cdnmedia.coapp.io/legacy/images/
            tmp = `https://cdnmedia.coapp.io/legacy/images/${tmp}?w=800`;

            return tmp;
        },
        classes() {
            return {
                contain: this.objectFit === 'contain',
                cover: this.objectFit === 'cover',
            };
        },
        placeholderClasses() {
            return {
                user: this.placeholder === 'user',
                image: this.placeholder !== 'user',
            };
        },
    },
    methods: {
        imgClick(event) {
            if (!this.lightbox) return;
            event.stopPropagation();
            this.showLightbox();
        },
        lightboxLoad() {
            this.lightboxLoaded = true;
        },
        showLightbox() {
            this.lightboxShow = true;
            document.body.classList.toggle('overflow-hidden', true);
        },
        hideLightbox() {
            this.lightboxLoaded = false;
            this.lightboxShow = false;
            document.body.classList.toggle('overflow-hidden', false);
        },
        imageLoaded() {
            this.$emit('loaded');
        },
    },
};
